import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'helpcenter.title',
    defaultMessage: 'Besoin d’aide ?',
  },
  faqTitle: {
    id: 'helpcenter.link.title',
    defaultMessage: 'Consulte notre FAQ',
  },
  faqDescription: {
    id: 'helpcenter.link.description',
    defaultMessage:
      'Nous avons rassemblé toutes nos réponses aux questions fréquentes ici.',
  },
  faqButton: {
    id: 'helpcenter.link.faqButton',
    defaultMessage: 'Trouver une réponse',
  },
  contactTitle: {
    id: 'helpcenter.link.title',
    defaultMessage: 'Envoie-nous un Email',
  },
  contactDescription: {
    id: 'helpcenter.link.description',
    defaultMessage:
      'Une adresse courriel unique pour vous répondre au plus vite.',
  },
  contactButton: {
    id: 'helpcenter.link.contactButton',
    defaultMessage: 'Contacter le support',
  },
});
